import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { revokeAuthentication } from "../store/reducers/reducer-auth";
import { resetAccount } from "../store/reducers/accountSlice";
import { resetAchPayment } from "../store/reducers/achPaymentSlice";
import { revokeToken } from "../store/reducers/reducer-tokens";
import { resetSubmitALoan } from "../store/reducers/submitALoanSlice";
import { resetReport } from "../store/reducers/reportDocumentSlice";
import { resetDashboard } from "../store/reducers/dashboardSlice";

const useLogout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch(revokeAuthentication());
    dispatch(resetAccount());
    dispatch(resetAchPayment());
    dispatch(revokeToken());
    dispatch(resetSubmitALoan());
    dispatch(resetReport());
    dispatch(resetDashboard());
    localStorage.clear();
    navigate("/login");
    window.location.reload();
  };

  return handleLogout;
};

export default useLogout;
